<mat-expansion-panel [expanded]="filters.expanded.brands" (opened)="opened()" (closed)="closed()">
    <mat-expansion-panel-header>
    <mat-panel-title>By Brands</mat-panel-title>
    </mat-expansion-panel-header>

  <mat-checkbox color="primary" *ngFor="let brand of defaults.brands" (change)="toggle(brand.record.name, $event.checked)" [checked]="filters.brands.indexOf(brand.record.name)!==-1" [disabled]="brand.count === 0"><img class="mini-verify-icon" src="assets/img/verified.png" *ngIf="brand.record.verified"/> {{ brand.record.name }} ({{ brand.count }})</mat-checkbox>
</mat-expansion-panel>
